import { apiRequest } from "@/services/api-client";
import {
  GetFriendsOutput,
  FriendRequestInput,
  FriendRequestOutput,
  RespondFriendRequestInput,
  RespondFriendRequestOutput,
  RemoveFriendInput,
  RemoveFriendOutput,
  SendKeyGiftInput,
  SendKeyGiftOutput,
  ClaimKeyGiftInput,
  ClaimKeyGiftOutput,
  GetLfgLobbiesOutput,
  GetFeedOutput,
} from "types/web-app";

export const getFriends = () =>
  apiRequest<GetFriendsOutput>("/social/friends");

export const sendFriendRequest = (input: FriendRequestInput) =>
  apiRequest<FriendRequestOutput>("/social/friend-request", {
    method: "POST",
    body: JSON.stringify(input),
  });

export const respondFriendRequest = (input: RespondFriendRequestInput) =>
  apiRequest<RespondFriendRequestOutput>("/social/respond-friend-request", {
    method: "POST",
    body: JSON.stringify(input),
  });

export const removeFriend = (input: RemoveFriendInput) =>
  apiRequest<RemoveFriendOutput>("/social/remove-friend", {
    method: "POST",
    body: JSON.stringify(input),
  });

export const sendKeyGift = (input: SendKeyGiftInput) =>
  apiRequest<SendKeyGiftOutput>("/social/send-key-gift", {
    method: "POST",
    body: JSON.stringify(input),
  });

export const claimKeyGift = (input: ClaimKeyGiftInput) =>
  apiRequest<ClaimKeyGiftOutput>("/social/claim-key-gift", {
    method: "POST",
    body: JSON.stringify(input),
  });

export const getLfgLobbies = () =>
  apiRequest<GetLfgLobbiesOutput>("/social/lfg-lobbies");

export const getFeed = () =>
  apiRequest<GetFeedOutput>("/social/feed");
